<template>
    <div class="ShareDialogue" @click="toggleSharing()">
        <div class="sd-container" @click="$event.stopPropagation()"><!--stopPropagation so toggleSharing() wont trigger on dialogue itself -->

            <!-- Room Link -->
            <h1 class="sd-text">{{ $t('Raum teilen') }}</h1>
            <input type="text" id="roomlink" class="sd-link" :value="roomLink" readonly  :style="{'width': inputWidth}">
            <md-button class="md-icon-button md-primary sd-copy" @click="copy('roomlink')">
                <LinkVariantIcon/>
            </md-button>

            <!-- Tour Link -->
            <h1 class="sd-text" style="margin-top: 25px">{{ $t('Tour teilen')}}</h1>
            <input type="text" id="tourlink" class="sd-link" :value="tourLink" readonly  :style="{'width': inputWidth}"> 
            <md-button class="md-icon-button sd-copy" @click="copy('tourlink')">
                <LinkVariantIcon/>
            </md-button>

        </div>
        
    </div>
</template>

<style scoped>
    .ShareDialogue{
        width: 100%;
        height: 100%; 
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #000000d0;
    }
   .sd-container{
        background: white;
        padding: 30px;
        border-radius: 10px;
    }
    .sd-link{
        padding: 10px;
        height: 50px;
        font-size: 16px;
        border: .5px solid rgb(180, 180, 180);
        border-radius: 6px;
        font-family: var(--primaryFont), Helvetica, Arial, sans-serif;
        color: rgb(43, 43, 43);
    }
    .sd-link:focus{
        outline: none;
    }
    .sd-link::selection{
        color: rgb(238, 238, 238);
    }
    .sd-copy{
        width: 50px;
        height: 50px;
        margin-left: 10px;
    }
    .md-icon-button{
        background: transparent !important;
        padding: 0;
        border-radius: 10px !important;
        margin-right: 0;
    }
    .md-ripple{
        padding: 0;
    }
    .md-button.md-theme-default{
        color: var(--primaryColor);
    }
    .sd-text{
        font-size: 20px;
        margin-top: 0px;
        margin-bottom: 10px;
    }
    .material-design-icon {
        height: 2.3em;
        width: 2.3em;
    }
    .material-design-icon> .material-design-icon__svg {
        fill: rgb(68, 68, 68);
        height: 2.3em;
        width: 2.3em;
    }
    @media (max-device-width: 900px){
        .sd-screen{
            z-index: 99;
        }
        .sd-container{
            width: 90%;
        }
        .sd-link {
            width: calc(100% - 70px) !important;
        }
    }
</style>
    
<script>
import LinkVariantIcon from 'vue-material-design-icons/LinkVariant.vue'

export default {
    inject: ['toggleSharing'],
    components: {LinkVariantIcon},
    computed: {
        // returns link of current room
        roomLink() {
            return window.location.toString();
        },

        // returns link of current tour (removing "/" at the end)
        tourLink() {
            return window.location.toString().split('?')[0].slice(0, -1);
        },

        // returns width for inputfields depending on the roomlink
        // Inputfields width wont adjust automatically thats why we need to calculate it whenever the Link changes
        inputWidth(){
            return window.location.toString().length-3 + 'ch'
        }
    },
	methods: {
        // Copy Link of inputfield to clipboard
        copy(id){
            document.getElementById(id).select();
            document.execCommand("copy");
        },  
    },
}

</script>